<template lang="pug">
  .HowAreWeDoing
    h1(:class="titleAnimation") 我们做的怎么样？
    h2 What we have achieved
    .events
      .tab
      .event(v-for="(item, index) in events" :class="[contentAnimation, `animateDelay-${index}`]")
        .contents
          img(:src="item.img" width="128px" height="128px")
          .content
            .title {{ item.time }}
            p.text {{ item.text }}
          .tab
    
</template>

<script>
  import Mixin from '../index.js'
  
  import {companyEvents} from "@/utils/images";
  const {韩正视察, 链上海南, 数字文明大会, 国际高新技术成果交流会, Zeus, 微看云, 公司成立, 重庆城市安全大脑} = companyEvents;

  export default {
    name: "HowAreWeDoing",
    mixins: [Mixin],
    data() {
      return {
        events: [
          {img: 韩正视察, time: '2020.05', text: '中共中央政治局常委、国务院副总理韩正前往海南生态软件园，视察由中国电子(CEC)与阿尔法云联袂打造的区块链试验区和数字经济示范工程。'},
          {img: 链上海南, time: '2020.05', text: '海南云（SSC+）与阿尔法云签约，联手共建“链上海南”数字经济超级样板'},
          {img: 数字文明大会, time: '2019.12', text: '出席"数字文明大会发布会",正式签约成为"链上海南"战略合作伙伴'},
          {img: 国际高新技术成果交流会, time: '2019.11', text: '参加“中国科技第一展”中国国际高新技术成果交流会'},
          {img: Zeus, time: '2019.06', text: 'ALPHA计算中台ZEUS完成自主研发投入运营'},
          {img: 微看云, time: '2019.05', text: 'ALPHA与微看数字-腾讯云智慧校园战略合作，成立微看云（深圳）有限公司'},
          {img: 公司成立, time: '2019.04', text: '阿尔法云计算（深圳）有限公司成立'},
          {img: 重庆城市安全大脑, time: '2019.01', text: 'ALPHA联合创始人IDO&POISSON参与建设阿里云城市安全大脑（重庆云盾）'},
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .HowAreWeDoing {
    VStack(center)
    padding 100px 0
    .events {
      width 1080px
      VStack()
      > .tab {
        height 115px + 11px
        width 100%
        position relative
        &::before {
          position absolute
          top 0
          left calc(50% - 8px)
          content ""
          width 12px
          height 12px
          border-radius 50%
          border 2px solid #f1f1f1
        }
        &::after {
          position absolute
          content ""
          top 14px
          left calc(50% - 1px)
          width 0
          height 115px
          border 1px solid #f1f1f1
        }
      }
    }
    .event {
      width 100%
      HStack(flex-start)
      .contents {
        width calc(50% + 7px)
        HStack()
      }
      img {
        border-radius 50%
        width 128px
        height 128px
      }
      .space {
        width 56px
      }
      .content {
        VStack(flex-end)
        width 314px
        margin 0 auto
        > .title {
          color #222222
          font-size 24px
          FontSetting(Montserrat)
          font-weight 400
        }
        > .text {
          max-width 100%
          color #999999
          font-size 16px
          FontSetting("思源黑体")
          font-weight 300
        }
      }
      .space2 {
        width 35px
      }
      .tab {
        width 12px
        height 12px
        border 1px solid #269bff
        margin-top 5px
        border-radius 50%
        position relative
        &::before {
          position absolute
          content ""
          top 14px
          left calc(50% - 1px)
          border 1px solid #f1f1f1
          width 0
          height 115px
        }
        &::after {
          position absolute
          content ""
          top 2px
          left 2px
          width 8px
          height 8px
          border-radius 50%
          background-color #2d9eff
        }
      }
      &:nth-of-type(odd) {
        flex-direction row-reverse
        .contents {
          flex-direction row-reverse
          > div {
            VStack(flex-start)
          }
        }
      }
    }
    @media (max-width ipadProScreenWidth) {
      .events {
        width 96%
      }
      .event {
        .space {
          width 46px
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      .events {
        width 100%
        .event {
          VStack(flex-end)
          width 50%
          padding-bottom 20px
          .contents {
            width 100%
          }
          .content {
            padding 0 10px
            width 100%
            height 150px
            box-sizing border-box
          }
          img {
            order 10
            align-self center
            display none
          }
          .tab {
            position absolute
            top 0
            right -7px
            &::before {
              height 153px
            }
          }
          &:nth-child(odd) {
            align-self flex-end
            .tab {
              right auto
              left -7px
            }
          }
        }
      }
    }
  }
</style>
